export const ru = {
    action: 'Действия'
};
